import { authService } from './useAuthenticationEffects.hook';

export const getAuthToken = async (): Promise<string | null> => {
    return authService.getAccessToken();
};
